import { __assign } from "tslib";
import React from 'react';
import useStyles from './styles';
export default (function (props) {
    var style = props.style, color = props.color;
    // @ts-ignore
    var classes = useStyles({ color: color });
    var defaultStyle = { width: 110, height: 110 };
    var styles = __assign(__assign({}, defaultStyle), style);
    return (React.createElement("svg", __assign({}, props, { className: classes.root, width: styles.width, height: styles.height, style: styles, viewBox: "25 25 50 50", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("circle", { className: classes.path, cx: "50", cy: "50", r: "20", fill: "none" })));
});
//# sourceMappingURL=CircleSpinnerIcon.js.map